import { postRequest, ApiResponse, getRequest } from "@/data/apiClient";

export interface Licence {
  app: string;
  concurrentUsers: number;
  issuedAt: string;
  expiresAt: string;
}

export interface LicencesResponse {
  licences: Licence[];
  licenceLines: string[];
}

export async function getLicences(): Promise<ApiResponse<LicencesResponse>> {
  return getRequest("licences");
}

export async function updateLicences(
  licenceLines: string[]
): Promise<ApiResponse<LicencesResponse>> {
  return postRequest("licencesSet", { licenceLines });
}
